/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_DeletedInputs */

const en_us2_gyms_deleted = /** @type {(inputs: Gyms_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gym deleted`)
};

const pt_br2_gyms_deleted = /** @type {(inputs: Gyms_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Academia excluída`)
};

const es_419_gyms_deleted = /** @type {(inputs: Gyms_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gimnasio eliminado`)
};

const pt_pt2_gyms_deleted = /** @type {(inputs: Gyms_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginásio eliminado`)
};

const fr_fr2_gyms_deleted = /** @type {(inputs: Gyms_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salle supprimée`)
};

const de_de2_gyms_deleted = /** @type {(inputs: Gyms_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio gelöscht`)
};

const it_it2_gyms_deleted = /** @type {(inputs: Gyms_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palestra eliminata`)
};

/**
* | output |
* | --- |
* | "Gym deleted" |
*
* @param {Gyms_DeletedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_deleted = /** @type {((inputs?: Gyms_DeletedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_DeletedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_deleted(inputs)
	if (locale === "es-419") return es_419_gyms_deleted(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_deleted(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_deleted(inputs)
	if (locale === "de-DE") return de_de2_gyms_deleted(inputs)
	if (locale === "it-IT") return it_it2_gyms_deleted(inputs)
	return en_us2_gyms_deleted(inputs)
});
export { gyms_deleted as "gyms.deleted" }